import Logo from "@/components/landing/Logo";
import { Mail, Instagram, Facebook, Youtube } from "lucide-react";
import { Link } from "react-router-dom";

const cols = [
    {
        title: "Méthode",
        links: [
            { label: "Neurosciences", href: "#methode" },
            { label: "Stoïcisme", href: "#methode" },
            { label: "Système Familial™", href: "#methode" },
        ],
    },
    {
        title: "Ressources",
        type: "internal",
        links: [
            { label: "Articles", to: "/articles" },
            { label: "Test gratuit", to: "/test" },
            { label: "Experts", to: "/#experts" },
        ],
    },
    {
        title: "Passer à l'action",
        type: "internal",
        links: [
            { label: "Faire le test gratuit", to: "/test" },
            { label: "Diagnostic offert", to: "/diagnostic" },
            { label: "Guide des Jeunes Héros", to: "https://payhip.com/b/gh2o0", external: true },
        ],
    },
];

const socials = [
    { icon: Mail, label: "Email", href: "mailto:bonjour@boostezvosneurones.com" },
    { icon: Instagram, label: "Instagram", href: "#" },
    { icon: Facebook, label: "Facebook", href: "#" },
    { icon: Youtube, label: "YouTube", href: "#" },
];

export default function Footer() {
    return (
        <footer data-testid="site-footer" className="bg-ink-950 text-ink-300 pt-20 pb-10">
            <div className="container-wide">
                <div className="grid lg:grid-cols-12 gap-12">
                    <div className="lg:col-span-5">
                        <Logo variant="light" />
                        <p className="mt-6 text-sm text-ink-400 leading-relaxed max-w-md">
                            Méthode basée sur les neurosciences, le stoïcisme et le Système Familial Haute
                            Performance™ pour accompagner les parents d'enfants de 6 à 20 ans vers
                            l'autonomie et la réussite.
                        </p>
                        <div className="mt-8 flex items-center gap-3">
                            {socials.map(({ icon: Icon, label, href }) => (
                                <a
                                    key={label}
                                    href={href}
                                    aria-label={label}
                                    data-testid={`footer-social-${label.toLowerCase()}`}
                                    className="grid place-items-center h-10 w-10 rounded-full border border-ink-700 text-ink-300 hover:bg-brand-500 hover:border-brand-500 hover:text-white transition-colors"
                                >
                                    <Icon className="h-4 w-4" strokeWidth={2} />
                                </a>
                            ))}
                        </div>
                    </div>

                    {cols.map((c) => (
                        <div key={c.title} className="lg:col-span-2">
                            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-ink-500">
                                {c.title}
                            </p>
                            <ul className="mt-5 space-y-3">
                                {c.links.map((l) =>
                                    c.type === "internal" ? (
                                        <li key={l.label}>
                                            {l.external ? (
                                                <a
                                                    href={l.to}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                                                    className="text-sm text-ink-300 hover:text-white transition-colors"
                                                >
                                                    {l.label}
                                                </a>
                                            ) : (
                                                <Link
                                                    to={l.to}
                                                    data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                                                    className="text-sm text-ink-300 hover:text-white transition-colors"
                                                >
                                                    {l.label}
                                                </Link>
                                            )}
                                        </li>
                                    ) : (
                                        <li key={l.label}>
                                            <a
                                                href={l.href}
                                                data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                                                className="text-sm text-ink-300 hover:text-white transition-colors"
                                            >
                                                {l.label}
                                            </a>
                                        </li>
                                    )
                                )}
                            </ul>
                        </div>
                    ))}

                    <div className="lg:col-span-3">
                        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-ink-500">
                            Une question ?
                        </p>
                        <a
                            href="mailto:bonjour@boostezvosneurones.com"
                            data-testid="footer-email"
                            className="block mt-4 font-semibold text-lg text-white hover:text-brand-300 transition-colors"
                        >
                            bonjour@<br />boostezvosneurones.com
                        </a>
                    </div>
                </div>

                <div className="mt-16 pt-8 border-t border-ink-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs text-ink-500">
                    <p data-testid="footer-copyright">
                        © {new Date().getFullYear()} Boostez Vos Neurones — Peggy &amp; Didier. Tous droits réservés.
                    </p>
                    <div className="flex flex-wrap items-center gap-5">
                        <a href="#" className="hover:text-white transition-colors">
                            Mentions légales
                        </a>
                        <a href="#" className="hover:text-white transition-colors">
                            Confidentialité
                        </a>
                        <a href="#" className="hover:text-white transition-colors">
                            CGV
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
}
